// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"492370eb","573":"1e7d617f","756":"8c789461","796":"1be3f501"}[chunkId] + ".chunk.js";
};